import { Box } from '@mui/material';

export default function Footer() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box
        className='footer'
      >
          
      </Box>
    </Box>
  );
}